<span [class.removido]="endereco.removido"><i class="fas fa-map-marker-alt mr-1"></i>
  {{(endereco.descricao) ? (endereco.descricao + ': ') : ''}} {{endereco.logradouro | json}},
  {{endereco.numero}}{{endereco.complemento != null ? ", " + endereco.complemento : ""}} -
  {{endereco.bairro}}  {{endereco.cep}} {{endereco.cidade?.nome}}/{{endereco.estado?.sigla}}
</span>

<i class="fe-edit fa-lg cpointer" (click)="abraModalEditarEndereco()" [hidden]="endereco.removido"></i>

